import { render, staticRenderFns } from "./ErrorPopup.vue?vue&type=template&id=21475049&scoped=true&"
import script from "./ErrorPopup.vue?vue&type=script&lang=js&"
export * from "./ErrorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21475049",
  null
  
)

export default component.exports